module.exports = __webpack_public_path__ + "img/billy_not_found.d1cb637a.svg";